<template>
  <div class="home" :class="isMobile ? 'home-mobile' : 'home-pc'" >
    <mini-menu color="#3D3D3D" sub-color="#2D1D64" title="首页" />
  </div>
</template>
 
<script>
import MiniMenu from "../components/MiniMenu.vue";
export default {
  name: "Home",
  components: {
    MiniMenu,
  },
  data() {
    return {
      isMobile: true,
    }
  },
  mounted() {
    if (window.screen.width < 500) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }
};
</script>
 
<style lang="scss" scoped>
.home {
  width: 100%;
  background: url('https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/home/bg.jpeg') no-repeat center;
  background-size: cover;
  position: relative;
  &-mobile {
    height: calc(100vh - 4.4rem);
  }
  &-pc {
    height: 6.43rem;
  }
}
</style>